module.exports = __webpack_public_path__ + "media/images/element/21-0fb020199f3927ee6cb5146a2245b5b7.svg";